import React, { useRef, useEffect, useState } from "react";
import MeetingFooter from "../MeetingFooter/MeetingFooter.component";
import Participants from "../Participants/Participants.component";
import "./MainScreen.css";
import { connect } from "react-redux";
import { setMainStream, updateUser } from "../../store/actioncreator";

const MainScreen = (props) => {
  const participantRef = useRef(props.participants);
  const [showParticipants, setShowParticipants] = useState(true)

  useEffect(() => {
    window.addEventListener('message', event => {
      const message = event.data;
      if (message === 'close') disconnectUser()
    });

    // eslint-disable-next-line
  }, [])

  const onMicClick = (micEnabled) => {
    if (props.stream) {
      const track = props.stream.getAudioTracks();
      if (track.lenght > 0) {
        track[0].enabled = micEnabled;
        props.updateUser({ audio: micEnabled });
      }
    }
  };
  const onVideoClick = (videoEnabled) => {
    if (props.stream) {
      const track = props.stream.getVideoTracks();
      if (track.lenght > 0) {
        track[0].enabled = videoEnabled;
        props.updateUser({ video: videoEnabled });
      }
    }
  };

  useEffect(() => {
    participantRef.current = props.participants;
  }, [props.participants]);

  const updateStream = (stream) => {
    for (let key in participantRef.current) {
      const sender = participantRef.current[key];
      if (sender.currentUser) continue;
      const peerConnection = sender.peerConnection
        .getSenders()
        .find((s) => (s.track ? s.track.kind === "video" : false));
      peerConnection.replaceTrack(stream.getVideoTracks()[0]);
    }
    props.setMainStream(stream);
  };

  const onScreenShareEnd = async () => {
    const localStream = await navigator.mediaDevices.getUserMedia({
      audio: true,
      video: true,
    });

    localStream.getVideoTracks()[0].enabled = Object.values(
      props.currentUser
    )[0].video;

    updateStream(localStream);

    props.updateUser({ screen: false });
  };

  const disconnectUser = () => {
    // Encerra a conexão WebRTC
    props.stream.getTracks().forEach((track) => track.stop());
    for (let key in participantRef.current) {
      const sender = participantRef.current[key];
      if (sender.peerConnection) {
        sender.peerConnection.close();
      }
    }
  
    // Remove o usuário atual da lista de participantes
    const { currentUser } = props;
    delete props.participants[currentUser.id];
    props.updateUser(null);
  
    // Envia mensagem para o iframe para que ele feche
    const iframe = document.getElementById("my-iframe");
    if (iframe) {
      iframe.contentWindow.postMessage("close", "*");
    }
  
    // Redireciona o usuário para a página inicial
    window.location.href = "/";
  };

  const onScreenClick = async () => {
    let mediaStream;
    if (navigator.getDisplayMedia) {
      mediaStream = await navigator.getDisplayMedia({ video: true });
    } else if (navigator.mediaDevices.getDisplayMedia) {
      mediaStream = await navigator.mediaDevices.getDisplayMedia({
        video: true,
      });
    } else {
      mediaStream = await navigator.mediaDevices.getUserMedia({
        video: { mediaSource: "screen" },
      });
    }

    mediaStream.getVideoTracks()[0].onended = onScreenShareEnd;

    updateStream(mediaStream);

    props.updateUser({ screen: true });
  };

  useEffect(() => {
    window.addEventListener('message', event => {
      const message = event.data;
      if (message === 'big') setShowParticipants(true)
      else  setShowParticipants(false)
    });

  }, [])

  return (
    <div className="wrapper">
      <div className="main-screen" style={!showParticipants ? { height: '80vh', width: '100%'  } : undefined}>
        <Participants showParticipants={showParticipants} />
      </div>

      <div className="footer" style={!showParticipants ? { height: '8.8vh', marginTop: '6.2vh'  } : undefined}>
        <MeetingFooter
          showParticipants={showParticipants}
          onScreenClick={onScreenClick}
          onMicClick={onMicClick}
          onVideoClick={onVideoClick}
        />
      </div>
    </div>
  );
};

// map

const mapStateToProps = (state) => {
  return {
    stream: state.mainStream,
    participants: state.participants,
    currentUser: state.currentUser,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setMainStream: (stream) => dispatch(setMainStream(stream)),
    updateUser: (user) => dispatch(updateUser(user)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MainScreen);

